import { createFileRoute } from '@tanstack/react-router'
import { ContractInsightsPage } from '../../../../features/contracts/insights/insights-page'

/** C4: compliance, renewals, problem assets, warranty and profitability (contracts.read, from the parent). */
export const Route = createFileRoute('/_app/service/contracts/insights')({
  staticData: { crumb: 'serviceContractInsights' },
  component: ContractInsightsPage,
})
